import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import styled from "styled-components";
import stylesForm from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.js";

const HeaderTextContainer = styled.div`
  display: flex;
  align-items: center;
`;

const selectDateMenuStyles = (theme) => ({
  ...selectStyles,
  ...stylesForm,
  ...buttonsStyle,
  cardHover: {
    "&:hover": {
      "& $cardHeaderHover": {
        transform: "translate3d(0, -10px, 0)",
      },
    },
  },
  gridNoPadding: {
    padding: "0 !important",
  },
  cardHeader: {
    padding: "10px",
  },
  cardHeaderHover: {
    transition: "all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)",
  },
  cardTitle: {
    margin: "0",
    marginLeft: ".4rem",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",

    fontSize: "1rem",
    display: "inline",
    textDecoration: "none",
  },
  grid: {
    padding: "0 .4rem",
    margin: "0",
    justifyContent: "center",
    width: "100%",
  },
  marginRow: {
    marginTop: ".5rem",
    marginBottom: ".4rem",
  },
});

export { selectDateMenuStyles, HeaderTextContainer };
